import { z } from 'zod';

//AcaoPrevCorretivaSchema

export const AcaoPrevCorretivaSchema = z.object({
  IdAcaoPrevCorretiva: z.number().nullable().optional(),
  IdAcaoQualidade: z.number(), 
  Tipo: z.enum(['C', 'P']),
  Numero: z.number().nullable().optional(),
  IdFuncionarioResponsavel: z.number().nullable().optional(),
  IdFuncionarioAnalise: z.number().nullable().optional(),
  Descricao: z.string().nullable().optional(),
  AnaliseEvidencia: z.string().nullable().optional(),
  DataPrevista: z.coerce.date().nullable().optional(),
  DataRealizado: z.coerce.date().nullable().optional(),
  DataAnalise: z.coerce.date().nullable().optional(),
  Delete: z.boolean().nullable().optional(),
  FoiEficaz: z.any()
    .nullable()
    .optional()
    .transform((value) => {
      // Converte o Input (Radio) para Output (Backend)
      if (value === 1 || value === '1') return true; 
      if (value === 0 || value === '0') return false; 
      return null; // Qualquer outra coisa (2) vira null
    }),
  
});



export type AcaoPrevCorretivaForm = z.infer<typeof AcaoPrevCorretivaSchema>;